import { render, staticRenderFns } from "./CherkizovoCardPartManual.vue?vue&type=template&id=090d0f80&scoped=true"
import script from "./CherkizovoCardPartManual.vue?vue&type=script&lang=js"
export * from "./CherkizovoCardPartManual.vue?vue&type=script&lang=js"
import style0 from "./CherkizovoCardPartManual.vue?vue&type=style&index=0&id=090d0f80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d0f80",
  null
  
)

export default component.exports